import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { withRouter, NavLink } from 'react-router-dom'
import { Work } from '@material-ui/icons'
import { List, ListItem, ListItemIcon, ListItemText, Collapse, Fab } from '@material-ui/core'
import { ExpandLess, ExpandMore, NavigateBefore, NavigateNext } from '@material-ui/icons'
import { SideMenuContainer, FabContainer } from './styled'
import {
  collapseSideMenu as toggleSideMenu,
  collapseSubMenu as toggleSubMenu
} from '../../ducks/app'

const SideMenu = (props) => {
  const { showMenu, menus, collapseMenu, toggleSideMenu, toggleSubMenu, userAdmin, userData } = props

  const checkRoles = (roleCode) => {
    if(userData?.role){
      return userData.role.includes(roleCode)
    }
    return false
  }

  return (
    <SideMenuContainer showMenu={showMenu} collapseMenu={collapseMenu} className='applicationSideMenu'>
      <List component='nav'>
        {menus.map((m, index) => m.hidden ? null : (m.admin && userAdmin) ? null :
          <div key={`${index}_${m.name}`} style={{ overflow: 'hidden' }} >
            <NavLink
              key={`menu_${index}_link`}
              onClick={(e) => m.collapse !== undefined ? e.preventDefault() : null}
              to={m.path || ''}
              isActive={(match, location) => {
                return (m.path !== '/' ? location.pathname.startsWith(m.path) : (location.pathname === m.path))
              }}
              activeClassName='active'
            >
              <ListItem
                button
                onClick={() => m.collapse !== undefined && toggleSubMenu(index)}
              >
                <ListItemIcon>{m.icon ? <m.icon /> : <div />}</ListItemIcon>
                {!collapseMenu ? <ListItemText primary={m.name} /> : null}
                {!collapseMenu && m.collapse !== undefined ?
                  m.collapse ? <ExpandMore /> : <ExpandLess /> : null
                }
              </ListItem>
            </NavLink>
            {!collapseMenu && m.subMenus && m.subMenus.length > 0 ?
              <Collapse in={!m.collapse}>
                <List component='div' disablePadding>
                  {m.subMenus.map((sm, ind) => (
                    <React.Fragment>
                      {
                        // sm.name === 'Supplier Code of Conduct' ?
                        //   checkRoles('FN002') ? //Supplier Code of Conduct
                        //     <NavLink
                        //       key={`sub_menu_${index}_${ind}_link`}
                        //       to={sm.path}
                        //       isActive={(match, location) => {
                        //         return (sm.path !== '/' ? (location.pathname.startsWith(sm.path) && ((location.pathname.length == sm.path.length) || location.pathname[(location.pathname.indexOf(sm.path) + (sm.path.length))] == '/')) : (location.pathname === sm.path))
                        //       }}
                        //       activeClassName='active'
                        //     >
                        //       <ListItem button className='subMenu' >
                        //         <ListItemIcon>{sm.icon ? <sm.icon /> : <div />}</ListItemIcon>
                        //         <ListItemText inset primary={sm.name} />
                        //       </ListItem>
                        //     </NavLink>
                        //     : null
                        //   :
                          <React.Fragment>
                            <NavLink
                              key={`sub_menu_${index}_${ind}_link`}
                              to={sm.path}
                              onClick={(e) => sm.collapse !== undefined ? e.preventDefault() : null}
                              isActive={(match, location) => {
                                return (sm.path !== '/' ? (location.pathname.startsWith(sm.path) && ((location.pathname.length == sm.path.length) || location.pathname[(location.pathname.indexOf(sm.path) + (sm.path.length))] == '/')) : (location.pathname === sm.path))
                              }}
                              activeClassName='active'
                            >
                              <ListItem
                                button
                                className='subMenu'
                                onClick={() => {
                                  if (sm.collapse !== undefined) {
                                    toggleSubMenu(index, ind)
                                  }
                                }}
                              >
                                <ListItemIcon>{sm.icon ? <sm.icon /> : <div />}</ListItemIcon>
                                <ListItemText inset primary={sm.name} />
                                {sm.collapse !== undefined ?
                                  sm.collapse ? <ExpandMore /> : <ExpandLess /> : null
                                }
                              </ListItem>
                            </NavLink>
                            {
                              sm.subMenus && sm.subMenus.length > 0 ?
                                <Collapse in={!sm.collapse}>
                                  <List component='div' disablePadding>
                                    {
                                      sm.subMenus.map((ssm, indx) => (
                                        <React.Fragment>
                                          <NavLink
                                            key={`sub_menu_${index}_${ind}_${indx}link`}
                                            to={ssm.path}
                                            isActive={(match, location) => {
                                              return (sm.path !== '/' ? (location.pathname.startsWith(ssm.path) && ((location.pathname.length === ssm.path.length) || location.pathname[(location.pathname.indexOf(ssm.path) + (ssm.path.length))] === '/')) : (location.pathname === ssm.path))
                                            }}
                                            activeClassName='active'
                                          >
                                            <ListItem button className='subMenu' >
                                              <ListItemIcon>{ssm.icon ? <ssm.icon /> : <div />}</ListItemIcon>
                                              <ListItemText inset primary={ssm.name} />
                                            </ListItem>
                                          </NavLink>
                                        </React.Fragment>
                                      ))
                                    }
                                  </List>
                                </Collapse> : null
                            }
                          </React.Fragment>
                      }
                    </React.Fragment>
                  ))}
                </List>
              </Collapse>
              : null}
          </div>
        )}
        {
          localStorage.getItem('mainDeptCode') === 'PROC'
            || localStorage.getItem('mainDeptCode') === 'proc'
            || localStorage.getItem('mainDeptCode') === 'PSOUR'
            || localStorage.getItem('mainDeptCode') === 'psour' ?
            // 1==1?
            <NavLink
              key={`menu_supplier_link`}
              // onClick={(e) => m.collapse !== undefined ? e.preventDefault() : null }
              to='/supplier'
              isActive={(match, location) => {
                return (location.pathname.startsWith('/supplier'))
              }}
              activeClassName='active'
            >
              <ListItem
                button
              // onClick={() => m.collapse !== undefined && toggleSubMenu(index)}
              >
                <ListItemIcon><Work /></ListItemIcon>
                <ListItemText primary='Supplier' />
              </ListItem>
            </NavLink>
            :
            null
        }
        {
          showMenu ?
            <FabContainer collapseMenu={collapseMenu}>
              <Fab size='small' color='primary' aria-label={collapseMenu ? 'Expand Menu' : 'Collapse Menu'} onClick={() => toggleSideMenu()}>
                {collapseMenu ? <NavigateNext /> : <NavigateBefore />}
              </Fab>
            </FabContainer> : null
        }
      </List>
    </SideMenuContainer>
  )
}

const mapStateToProps = (state) => ({
  showMenu: state.app.showSideMenu,
  collapseMenu: state.app.collapseSideMenu,
  menus: state.app.menus,
  userAdmin: state.authen.userAdmin,
  userData: state.authen.user||{}
})

const mapDispatchToProps = {
  toggleSideMenu,
  toggleSubMenu
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history
  })),
  lifecycle({
    componentDidMount() {
    }
  })
)

export default withRouter(enhance(SideMenu))